/*
 * @Author: 黄贺林
 * @Date: 2024-01-15 17:28:22
 * @LastEditTime: 2025-02-26 11:46:11
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */
import axios from "axios";
import { i18n } from "@/lang";
import store from "@/store/index";
import Vue from "vue";
import { getQueryParam } from "@/utils/common";
import { accountSender } from "./anycubic_axios";


// 创建一个 CancelToken 源
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

let baseURL = process.env.VUE_APP_BASE_API
let urlList = ['/v3/printer/getList', '/v3/lan_network/index'] //不用token的接口

// 软包本地包形式
if (process.env.VUE_APP_NODE_ENV === 'anycubicSlicer') {
  const prod = getQueryParam(location.hash, 'prod') || localStorage.getItem('prod');
  let host = window.location.host;
  if (host == '') {
    host = 'localhost';
  }
  baseURL = `https://${host}${prod === '1' ? '/p/p/workbench/api' : '/p/t/workbench/api'}`
}

const service = axios.create({
  baseURL: baseURL,
  timeout: 10000
});

service.interceptors.request.use(
  async function (config) {
    if (!store.getters.GET_TOKEN && urlList.indexOf(config.url) == -1) {
      config.cancelToken = source.token;
      source.cancel('请求被取消');
    }
    await accountSender.get('headers', null).then((res) => {
      const data = res.data
      if (window.location.host === '') {
        config.baseURL = config.baseURL.replace('localhost', data.host);
      } else {
        config.baseURL = config.baseURL.replace(window.location.host, data.host);
      }
      if (data.status == 1) {
        Object.keys(data.headers).forEach((key) => {
          config.headers[key] = data.headers[key]
        })
      }
    })
    return config;

  },
  // error
  (error) => {
    return Promise.reject(error);
  }
);

let tokenExpire = false; //是否返回10001状态码，防止多个接口多个弹窗
let timer;
let timeout;
service.interceptors.response.use(
  (response) => {
    const data = response.data;
    const url = response.config.url
    if (data.code === 10001 && !tokenExpire && store.getters.GET_TOKEN) {
      tokenExpire = true;
      // 退出提示
      // Vue.prototype.$alert(i18n.tc('RemoteLogin'), i18n.tc("Prompt"), {
      //     confirmButtonText: i18n.tc("ok"),
      //     callback: action => {
      //         logout()
      //     },
      //     showClose: false,
      //     center: true
      // });
      // 这里不要主动触发退出，主程序会自己处理
      // account.logout();
    }
    if (data.code !== 10001 && data.code !== 1 && url !== '/v3/printer/getPrinterFileDetails') {
      // 错误提示只提示最后一次
      if (timer) clearTimeout(timer);
      timer = setTimeout((dt) => {
        Vue.prototype.$message.error(dt.msg);
        store.dispatch("SET_LOADING_FALSE");
        clearTimeout(timer)
      }, 1000, data);
    }
    return data;
  },
  // 响应error
  (error) => {
    const config = error.config;
    store.commit("SET_LAYOUT_LOADING", false);
    // 取消请求
    if (error.code == 'ERR_CANCELED') {
      return Promise.reject();
    }

    if (error.message.includes("timeout")) {
      if (!timeout) {
        // 如果计时器不存在
        // Vue.prototype.$message.error(error.message); // 执行函数
        Vue.prototype.$message.error(i18n.tc("request_timeout")); // 执行函数
        timeout = setTimeout(() => {
          timeout = null; // 清空计时器变量
        }, 3 * 1000); // 创建计时器，在指定时间后重置计时器变量
      }
      return Promise.reject(error.message); // reject这个错误信息
      // 判断请求异常信息中是否含有超时timeout字符串
    }
    if (!timeout) {
      // 如果计时器不存在
      Vue.prototype.$message.error(error.message); // 执行函数
      timeout = setTimeout(() => {
        timeout = null; // 清空计时器变量
      }, 3 * 1000); // 创建计时器，在指定时间后重置计时器变量
    }
    return Promise.reject(error);
  }
);

export default service;
